/**
 * Used to explicitly only show the OPEN/CLOSED status on specific lifts. All other lifts are ignored.
 *
 * This is currently used in pre-season of Wengen.
 */
import * as resorts from '~/config/ids/idsResorts';

export const PRE_SEASON_LIFTS = [
    { sismediaResortId: '1', sismediaLiftId: '18' },
    { sismediaResortId: '1', sismediaLiftId: '20' },
    { sismediaResortId: '1', sismediaLiftId: '25' },
    { sismediaResortId: '1', sismediaLiftId: '27' },
    { sismediaResortId: '1', sismediaLiftId: '28' },
    { sismediaResortId: '1', sismediaLiftId: '600' },
];

export const IS_PRE_SEASON = process.env.IS_PRE_SEASON === 'true';

export const PRE_SEASON = {
    [resorts.WINTER_GW]: process.env.IS_PRE_SEASON_GW === 'true',
    [resorts.WINTER_MS]: process.env.IS_PRE_SEASON_MS === 'true',
    [resorts.WINTER_GF]: process.env.IS_PRE_SEASON_GF === 'true',
};
